/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

export interface EnvironmentModel {
  /**
   * determina env production
   */
  production: boolean;

  /**
   * codice per identificare l'env
   */
  envCode: string;

  /**
   * codice che identifica il cliente (la banca)
   */
  accountCode: string;

  /**
   * codice applicazione
   */
  appCode: 'cqs' | 'loans';

  /**
   * codice flusso
   */
  flowCode: 'standalone' | 'operation';

  /**
   * base url
   */
  baseUrl: string;

  /**
   * base url per le api
   */
  apiBaseUrl: string;

  /**
   * base url per le api di login
   */
  securityBaseUrl: string;

  /**
   * abilita modalità dev
   */
  devMode?: boolean;

  /**
   * url della demo
   */
  demoDBUrl?: string;

  /**
   * id dataset su cui si basa la demo
   */
  demoDatasetId?: string;
}
